module.exports = __webpack_public_path__ + "static/42ca66c32783fdee4ca9fb566c401259bd498a184e44005c185e69c56a499771-1171b00b5ca53bdf945f66560ef4f1de.jpeg";